export default {
  'raSessionReview.page.title': 'Session Review',
  'raSessionReview.page.comingSoon':
    'Session search and replay are coming soon. This page is currently scaffolding only.',
};
